import React, { useEffect, useState } from 'react';
import { Avatar, Typography, Spin } from 'antd';
import { useSelector } from 'react-redux';

const { Text } = Typography;

interface RootState {
  deepResearch: {
    agentStatus: string[];
  };
}

export const LoadingMessage: React.FC = () => {
  const agentStatus = useSelector((state: RootState) => state.deepResearch.agentStatus);
  const [currentStatus, setCurrentStatus] = useState<string>('Thinking...');

  // Update current status when agentStatus changes
  useEffect(() => {
    if (agentStatus.length > 0) {
      // Show the latest status
      setCurrentStatus(agentStatus[agentStatus.length - 1]);
    } else {
      setCurrentStatus('Thinking...');
    }
  }, [agentStatus]);

  return (
    <div className="message ai-message loading-message">
      <Avatar className="message-avatar" style={{ backgroundColor: '#52c41a' }}>
        <Text className="avatar-text" style={{ color: 'white' }}>AI</Text>
      </Avatar>
      <div className="loading-content">
        <div className="status-line">
          <Spin size="small" />
          <Text className="status-text">{currentStatus}</Text>
        </div>
      </div>
    </div>
  );
};
